(function () {
  'use strict';

  /* @ngdoc object
   * @name crewViolations
   * @description
   *
   */
  angular
    .module('pairingAssignmentComplementConfirmationModal', [
      'ui.router'
    ]);
}());
